// @ts-check
import { checkArrayOnlyType } from 'libs/types/checkTypes';

/**
 * @function addAppId
 * @param {Object[]} values
 * @param {string} values.userId
 * @param {string} values.roleGroupId
 * @returns {Array.<{userId:string, roleGroupId:string, appId: string}>}
 */
function addAppId(values) {
	checkArrayOnlyType(values);

	const added = values.map((value) => {
		let id = '';
		const length = value.roleGroupId.length;

		if (length === 3) {
			id = value.roleGroupId.charAt(0);
		} else if (length === 4) {
			id = value.roleGroupId.slice(0, 2);
		}

		return { ...value, appId: id };
	});

	return added;
}

/**
 * @function makeFixedUserGroups
 * @param {Object[]} userGroups
 * @param {string} userGroups.id
 * @param {string} userGroups.name
 * @param {string} userGroups.appId
 * @param {Object[]} loggedInUserGroups
 * @param {string} loggedInUserGroups.userId
 * @param {string} loggedInUserGroups.roleGroupId
 * @returns {Array.<{id:String, name:String, appId:String}>}
 */
function makeFixedUserGroups(userGroups, loggedInUserGroups) {
	checkArrayOnlyType(userGroups, loggedInUserGroups);

	const addedLoggedInUserGroups = addAppId(loggedInUserGroups);

	const result = userGroups.filter(
		(userGroup) =>
			!addedLoggedInUserGroups.some(
				(loggedInUserGroup) => userGroup.appId === loggedInUserGroup.appId,
			),
	);

	return result;
}

export default makeFixedUserGroups;
